<template>
  <div class="customer-container">
    <div class="customer-header normal-button">
      <span style="flex: 1" class="title" @click="hidden = !hidden"
        >Customer {{ customerIndex + 1 }}</span
      >
      <span
        v-if="customerIndex > 0"
        class="remove-button"
        @click="() => $emit('onRemove', customerIndex)"
        >Remove</span
      >
      <img
        @click="hidden = !hidden"
        src="@/assets/ic_triangle_dark.png"
        style="height: 15px; widht: auto; margin-left: 10px"
      />
    </div>
    <div v-if="hidden">
      <div class="body-container information">
        <div class="text-field" v-loading="gettingName">
          <input v-model="customer.fullName" class="input" placeholder="Name" />
        </div>
      </div>
      <div class="body-container service">
        <span class="title mb20">Service</span>
        <div class="list-service">
          <service-item
            v-for="(item, index) in services"
            :index="index"
            :key="item.service_id"
            :title="item.type"
            :isSelected="
              customer.selectedServices.find(
                (s) => s.service_id == item.service_id
              ) != null
            "
            v-on:onItemClick="() => onSelectedItem(index)"
          />
        </div>
        <span class="customer-note" v-if="customer.customerNote"
          >Notes: {{ customer.customerNote }}</span
        >
      </div>
      <div class="body-container technician">
        <span class="title mb20">Request Technician</span>
        <div
          class="btn-technician-container normal-button"
          @click="() => $emit('openTechnicianNote', customerIndex)"
        >
          <span v-if="customer.tech.full_name" class="tect-text">{{
            customer.tech.full_name
          }}</span>
          <span v-else class="tect-placeholder">Select technician</span>
          <img
            src="@/assets/ic_triangle.png"
            style="height: 15px; widht: auto"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceItem from "./ServiceItem";
export default {
  components: {
    ServiceItem,
  },
  name: "CustomerItem",
  props: {
    customer: {
      type: Object,
      isRequired: true,
    },
    gettingName: {
      type: Boolean,
      default: false,
    },
    services: {
      type: Array,
      isRequired: true,
    },
    customerIndex: {
      type: Number,
      isRequired: true,
    },
  },
  data() {
    return {
      hidden: true,
    };
  },
  methods: {
    onSelectedItem(index) {
      const item = this.services[index];
      if (item.type == "Other") {
        // this.dialogNote = true;
        this.$emit("openOtherNote", this.customerIndex);
        return;
      }
      const isSelected =
        this.customer.selectedServices.find(
          (s) => s.service_id == item.service_id
        ) != null;
      if (isSelected) {
        const indexSelected = this.customer.selectedServices.indexOf(item);
        if (indexSelected > -1) {
          this.customer.selectedServices.splice(indexSelected, 1);
        }
      } else {
        this.customer.selectedServices.push(item);
      }
    },
  },
};
</script>

<style lang="scss">
.customer-container {
  padding: 20px 0;
  margin: 0 20px 20px 20px;
  box-shadow: 0 5px 10px rgba($color: #000000, $alpha: 0.1);
  border-radius: 5px;
  background-color: #fff9ec;
  .customer-header {
    margin: 0 20px 0 20px;
    display: flex;
    align-items: center;
    .remove-button {
      font-style: italic;
      font-weight: 600;
      font-size: 16px;
    }
  }
  .el-collapse {
    border-bottom: none;
    border-top: none;
  }
  .el-collapse-item__wrap {
    background-color: transparent;
    border-bottom: none;
  }
  .el-collapse-item__header {
    font-weight: bold;
    font-size: 20px;
    margin: 0 20px;
    background-color: transparent;
    height: 50px;
  }
}
</style>

<style lang="scss" scoped>
.customer-container {
  .body-container {
    display: flex;
    flex-direction: column;
    ::placeholder {
      color: #696969;
      font-weight: 600;
    }
    .text-field {
      margin-bottom: 20px;
    }
    .input {
      width: 100%;
      border-radius: 5px;
      border: 1px solid #eeeeee;
      background-color: #f9f7f1;
      height: 50px;
      font-size: 16px;
      font-weight: 600;
      outline: none;
      outline-style: none;
      padding: 0 20px;
      box-shadow: none;
    }
    .customer-note {
      margin-top: 15px;
      margin-bottom: 10px;
    }
  }
  .information {
    margin: 30px 20px 0 20px;
    .source-view {
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 25px;
      .source-text {
        font-weight: bold;
        font-size: 20px;
      }
    }
  }
  .service {
    margin: 10px 20px 0 20px;
    .list-service {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .title {
    font-weight: bold;
    font-size: 18px;
  }
  .technician {
    margin: 15px 20px 10px 20px;
    .btn-technician-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      height: 50px;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      background-color: #f9f7f1;
      .tect-placeholder {
        font-weight: 600;
        color: #9b9b9b;
        font-size: 16px;
      }
      .tect-text {
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
}
</style>